<template>
  <div>
    <div class="banner" v-if="bannerInfo.videoList">
      <div
        :class="['banner__desc', showDesc && 'active']"
        @click="showDesc = true"
      >{{ desc }}</div>
      <div class="carousel">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide v-for="it of bannerInfo.videoList" :key="it.caseId">
            <img :src="it.ottImgUrl" @click="playVideo(it)" alt="">
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="carousel__items">
          <div
            :class="['carousel__item', {active: index == current}]"
            v-for="(it, index) of bannerInfo.videoList"
            @click="handleChange(index)"
            :key="index"
          >
            {{it.ottTitle}}
            <p>{{it.subName}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'banner',
  components: {
    QrcodeVue
  },
  props: {
    name: String,
    desc: String,
    bannerInfo: Object
  },
  data: function () {
    return {
      isFocus: false,
      showDesc: false,
      current: 0,
      swiperOptions: {
        initialSlide: 0,
        loop: false,
        speed: 400,
        autoplay: 3000,
        direction: 'vertical',
        mousewheelControl: true,
        onTransitionStart: (swiper) => {
          this.current = swiper.realIndex
        }
      }
    }
  },
  methods: {
    playVideo: function (video) {
      this.$emit('play', video)
    },
    handleChange: function (idx) {
      this.current = idx
      this.swiper.slideTo(idx, 1000, false)
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  }
}

</script>

<style>
.carousel__item p {
  display: none;
}
.carousel__item.active p {
  display: block;
}
.klk .banner {
  background-color: #eaf6ff;
}
.klk .carousel__item.active,
.klk .carousel__item.active p {
  color: #f4bf24;
}
.xzs .banner__desc {
  color: #4c794a;
}
.xzs .banner {
  background-color: #f1fde3;
}
.xzs .carousel__item.active,
.xzs .carousel__item.active p {
  display: block;
  color: #86ff95;
}
.banner {
  padding: 30px;
  box-sizing: border-box;
  background-color: #ecf9ff;
  margin-bottom: 80px;
}
.banner__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.banner__title {
  font-size: 30px;
  color: #232222;
  font-weight: 400;
  margin: 0;
}
.banner__icons {
  display: flex;
  align-items: center;
}
.banner__icon {
  display: flex;
  align-items: center;
  margin-right: 29px;
}
.banner__icon:not(:first-child) {
  cursor: pointer;
}
.banner__icon span {
  font-size: 15px;
  color: rgba(145, 145, 145, 0.8);
}
.banner__icon img {
  width: 28px;
  height: 28px;
  padding-right: 6px;
}
.banner__desc {
  cursor: pointer;
  font-size: 14px;
  line-height: 25px;
  letter-spacing: 2.1px;
  color: #45617c;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  font-family: 'SiYuan';
  white-space: pre-line;
}
.carousel {
  position: relative;
  margin-top: 30px;
  height: 540px;
  overflow: hidden;
  background: #a2d1e5;
}
.carousel__list {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}
.carousel__list li {
  list-style: none;
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.carousel__list li img {
  width: 100%;
  height: 100%;
}
.list-enter-from {
  transform: translateY(100%);
}
.list-leave-to {
  transform: translateY(-100%);
}
.list-enter-to,
.list-leave-from {
  transform: translateY(0);
}
.list-enter-active,
.list-leave-active {
  transition: transform 0.6s ease-out;
}
.carousel__items {
  position: absolute;
  top: 0;
  right: 0;
  padding: 30px 0 0;
  width: 236px;
  height: 100%;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1;
}
.carousel__item {
  padding-left: 30px;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.8);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.carousel__item.active {
  font-size: 22px;
  line-height: 28px;
  color: #00b6ff;
  padding-top: 16px;
  padding-bottom: 17px;
  background-color: rgba(0, 0, 0, 0.4);
}
.carousel__item.active p {
  margin: 0;
  font-size: 14px;
  color: #00b6ff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.qr__modal {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 340px;
  height: 287px;
  background-color: #fff;
  border-radius: 5px;
}
.qr__title {
  margin: 31px 0 8px;
  font-size: 22px;
  color: #484848;
}
.qr__tips {
  font-size: 14px;
  font-weight: 400;
  color: #484848;
  margin-top: 11px;
}
.qr__close {
  position: absolute;
  top: -7px;
  right: -7px;
  cursor: pointer;
  width: 29px;
  height: 29px;
}
.swiper-container {
  width: 100%;
  height: 540px!important;
  overflow: hidden;
}
.swiper-container .swiper-slide {
  height: 540px!important;
}
.swiper-slide img{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue